/*** IMPORTS FROM imports-loader ***/
(function() {

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Sigma"] = factory();
	else
		root["Sigma"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	__webpack_require__(1);

	__webpack_require__(2);

	__webpack_require__(3);

	__webpack_require__(4);

	__webpack_require__(5);

	__webpack_require__(6);

	__webpack_require__(7);

	__webpack_require__(8);

	__webpack_require__(9);

	__webpack_require__(10);

	__webpack_require__(11);

	__webpack_require__(12);

	__webpack_require__(13);

	__webpack_require__(14);

/***/ },
/* 1 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This edge renderer will display edges as curves.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.curve = function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        sSize = source[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'];

	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, sSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x1, cp.y1, cp.x2, cp.y2, tX, tY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, tX, tY);
	    }
	    context.stroke();
	  };
	})();

	}.call(window));

/***/ },
/* 2 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This edge renderer will display edges as arrows going from the source node
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.arrow = function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        size = edge[prefix + 'size'] || 1,
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        aSize = Math.max(size * 2.5, settings('minArrowSize')),
	        d = Math.sqrt(Math.pow(tX - sX, 2) + Math.pow(tY - sY, 2)),
	        aX = sX + (tX - sX) * (d - aSize - tSize) / d,
	        aY = sY + (tY - sY) * (d - aSize - tSize) / d,
	        vX = (tX - sX) * aSize / d,
	        vY = (tY - sY) * aSize / d;

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    context.lineTo(
	      aX,
	      aY
	    );
	    context.stroke();

	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();

	}.call(window));

/***/ },
/* 3 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This edge renderer will display edges as curves with arrow heading.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.curvedArrow =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        size = edge[prefix + 'size'] || 1,
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        aSize = Math.max(size * 2.5, settings('minArrowSize')),
	        d,
	        aX,
	        aY,
	        vX,
	        vY;

	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, tSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);

	    if (source.id === target.id) {
	      d = Math.sqrt(Math.pow(tX - cp.x1, 2) + Math.pow(tY - cp.y1, 2));
	      aX = cp.x1 + (tX - cp.x1) * (d - aSize - tSize) / d;
	      aY = cp.y1 + (tY - cp.y1) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x1) * aSize / d;
	      vY = (tY - cp.y1) * aSize / d;
	    }
	    else {
	      d = Math.sqrt(Math.pow(tX - cp.x, 2) + Math.pow(tY - cp.y, 2));
	      aX = cp.x + (tX - cp.x) * (d - aSize - tSize) / d;
	      aY = cp.y + (tY - cp.y) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x) * aSize / d;
	      vY = (tY - cp.y) * aSize / d;
	    }

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x2, cp.y2, cp.x1, cp.y1, aX, aY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, aX, aY);
	    }
	    context.stroke();

	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();

	}.call(window));

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.curve =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        size = settings('edgeHoverSizeRatio') * (edge[prefix + 'size'] || 1),
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        sSize = source[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'];

	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, sSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x1, cp.y1, cp.x2, cp.y2, tX, tY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, tX, tY);
	    }
	    context.stroke();
	  };
	})();

	}.call(window));

/***/ },
/* 5 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.arrow =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        size = edge[prefix + 'size'] || 1,
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'];

	    size = (edge.hover) ?
	      settings('edgeHoverSizeRatio') * size : size;
	    var aSize = size * 2.5,
	        d = Math.sqrt(Math.pow(tX - sX, 2) + Math.pow(tY - sY, 2)),
	        aX = sX + (tX - sX) * (d - aSize - tSize) / d,
	        aY = sY + (tY - sY) * (d - aSize - tSize) / d,
	        vX = (tX - sX) * aSize / d,
	        vY = (tY - sY) * aSize / d;

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    context.lineTo(
	      aX,
	      aY
	    );
	    context.stroke();

	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();

	}.call(window));

/***/ },
/* 6 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.curvedArrow =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        size = settings('edgeHoverSizeRatio') * (edge[prefix + 'size'] || 1),
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        d,
	        aSize,
	        aX,
	        aY,
	        vX,
	        vY;

	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, tSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);

	    if (source.id === target.id) {
	      d = Math.sqrt(Math.pow(tX - cp.x1, 2) + Math.pow(tY - cp.y1, 2));
	      aSize = size * 2.5;
	      aX = cp.x1 + (tX - cp.x1) * (d - aSize - tSize) / d;
	      aY = cp.y1 + (tY - cp.y1) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x1) * aSize / d;
	      vY = (tY - cp.y1) * aSize / d;
	    }
	    else {
	      d = Math.sqrt(Math.pow(tX - cp.x, 2) + Math.pow(tY - cp.y, 2));
	      aSize = size * 2.5;
	      aX = cp.x + (tX - cp.x) * (d - aSize - tSize) / d;
	      aY = cp.y + (tY - cp.y) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x) * aSize / d;
	      vY = (tY - cp.y) * aSize / d;
	    }

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x2, cp.y2, cp.x1, cp.y1, aX, aY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, aX, aY);
	    }
	    context.stroke();

	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();

	}.call(window));

/***/ },
/* 7 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.dashed =
	    function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');

	    context.save();

	    context.setLineDash([8,3]);
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 8 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.dotted =
	    function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');

	    context.save();

	    context.setLineDash([2]);
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 9 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.parallel =
	    function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        c,
	        d,
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');

	    // Intersection points of the source node circle:
	    c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);

	    // Intersection points of the target node circle:
	    d = sigma.utils.getCircleIntersection(tX, tY, size, sX, sY, dist);

	    context.save();

	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(c.xi, c.yi);
	    context.lineTo(d.xi_prime, d.yi_prime);
	    context.closePath();
	    context.stroke();

	    context.beginPath();
	    context.moveTo(c.xi_prime, c.yi_prime);
	    context.lineTo(d.xi, d.yi);
	    context.closePath();
	    context.stroke();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 10 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edgehovers');

	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.tapered =
	    function(edge, source, target, context, settings) {
	    // The goal is to draw a triangle where the target node is a point of
	    // the triangle, and the two other points are the intersection of the
	    // source circle and the circle (target, distance(source, target)).
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        prefix = settings('prefix') || '',
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');

	    // Intersection points:
	    var c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);

	    context.save();

	    // Turn transparency on:
	    context.globalAlpha = 0.65;

	    // Draw the triangle:
	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(tX, tY);
	    context.lineTo(c.xi, c.yi);
	    context.lineTo(c.xi_prime, c.yi_prime);
	    context.closePath();
	    context.fill();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 11 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This method renders the edge as a dashed line.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.dashed = function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    context.save();

	    if (edge.active) {
	      context.strokeStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.strokeStyle = color;
	    }

	    context.setLineDash([8,3]);
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 12 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This method renders the edge as a dotted line.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.dotted = function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    context.save();

	    if (edge.active) {
	      context.strokeStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.strokeStyle = color;
	    }

	    context.setLineDash([2]);
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 13 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This method renders the edge as two parallel lines.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.parallel = function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        c,
	        d,
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    // Intersection points of the source node circle:
	    c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);

	    // Intersection points of the target node circle:
	    d = sigma.utils.getCircleIntersection(tX, tY, size, sX, sY, dist);

	    context.save();

	    if (edge.active) {
	      context.strokeStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.strokeStyle = color;
	    }

	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(c.xi, c.yi);
	    context.lineTo(d.xi_prime, d.yi_prime);
	    context.closePath();
	    context.stroke();

	    context.beginPath();
	    context.moveTo(c.xi_prime, c.yi_prime);
	    context.lineTo(d.xi, d.yi);
	    context.closePath();
	    context.stroke();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ },
/* 14 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {

	;(function() {
	  'use strict';

	  sigma.utils.pkg('sigma.canvas.edges');

	  /**
	   * This method renders the edge as a tapered line.
	   * Danny Holten, Petra Isenberg, Jean-Daniel Fekete, and J. Van Wijk (2010)
	   * Performance Evaluation of Tapered, Curved, and Animated Directed-Edge
	   * Representations in Node-Link Graphs. Research Report, Sep 2010.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.tapered = function(edge, source, target, context, settings) {
	    // The goal is to draw a triangle where the target node is a point of
	    // the triangle, and the two other points are the intersection of the
	    // source circle and the circle (target, distance(source, target)).
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        prefix = settings('prefix') || '',
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);

	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }

	    // Intersection points:
	    var c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);

	    context.save();

	    if (edge.active) {
	      context.fillStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.fillStyle = color;
	    }

	    // Turn transparency on:
	    context.globalAlpha = 0.65;

	    // Draw the triangle:
	    context.beginPath();
	    context.moveTo(tX, tY);
	    context.lineTo(c.xi, c.yi);
	    context.lineTo(c.xi_prime, c.yi_prime);
	    context.closePath();
	    context.fill();

	    context.restore();
	  };
	})();

	}.call(window));

/***/ }
/******/ ])
});
;
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./sigma/edges.js
// module id = 100
// module chunks = 0